import React, { useState, useEffect } from 'react';
import { Consumer } from "../../context";
import { Helmet } from "react-helmet";
import Header from "../../components/header/header";
import SidebarAdministracion from "../../components/header/sidebarAdministracion";
import DinamicModal from '../../components/dinamicModal/dinamicModal';
import Paginador from "../../components/paginador/paginador";
import Controls from '../../components/controls/controls';
import Permissions from '../../middlewares/Permissions';
import PosicionesTable from '../../components/personalSeguridad/posicionesTable';
import PosicionForm from '../../components/personalSeguridad/formPosicion';
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';
import sortableData from '../../helpers/sortableDataTable';

const request = new Request();

const Posiciones = ({ context }) => {
	const [logo, setLogo] = useState(require ("../../img/logo-AppMosphera-r.png"));
	const [lectura, setLectura] = useState(false);
	const [escritura, setEscritura] = useState(false);
	const [loadingPersonal, setloadingPersonal] = useState(false);
	const [loadingSave, setloadingSave] = useState(false);
	const [page, setPage] = useState(1);
	const [pageLength, setPageLength] = useState(20);
	const [posiciones, setPosiciones] = useState([]);
	const [filter, setFilter] = useState('');
	const [message, setMessage] = useState(false);
	const [posicion, setPosicion] = useState('');
	const [filterColumn, setFilterColumn] = useState({
		col: '',
		filt: ''
	});
	const [direccion, setDireccion] = useState({
		posicion: 'desc'
	});
	const [submenu, setSubmenu] = useState('');

	useEffect(() => {
		validarPermisos();
	}, []);

	useEffect(() => {
		getSubmenu();
		getPosiciones();
	}, [lectura]);

	async function validarPermisos(){
		let permisos = new Permissions();
		let permisosInfo = await permisos.getResult();

		setEscritura(permisosInfo.escritura);
		setLectura(permisosInfo.lectura);
	}

	async function getSubmenu() {
		const submenu = await context.getSubmenuAdminName();
		if (submenu) {
			setSubmenu(submenu);
		}
	}

	async function getPosiciones() {
		setloadingPersonal(true);

		const response = await request.post("/personal/posiciones/get", {id_fraccionamiento: localStorage.getItem('frac')});
		if(Array.isArray(response.posiciones)) {
			setPosiciones(response.posiciones);
		} else {
			setPosiciones([]);
		}

        setloadingPersonal(false);
	}

	async function paginatorChange( length ){
		setPageLength(length);
		setPage(1);
	}

	async function handleSubmit(event) {
		event.preventDefault();
		setloadingSave(true);
		const form = event.target;
		const data = {
			id_fraccionamiento: localStorage.getItem('frac'),
			posicion: form.posicion_title.value
		}

		const response = await request.post('/personal/posiciones/create', data);

		if (response.created) {
			closeModal('modal-nueva-posicion');
            reload();
            cogoToast.success('Posición creada.', {
                position: 'bottom-right',
            });
        } else {
            cogoToast.error(response.message || 'No se pudo crear la posición.', {
                position: 'bottom-right',
            });
        }

		setPosicion('');
		setloadingSave(false);
	}

	function openModal(idModal) {
		const modal = document.getElementById(idModal);
		if(modal) {
			modal.classList.remove('hide-dinamic-modal');
			modal.classList.add('show-dinamic-modal');
		}
	}

	function closeModal(idModal) {
		const modal = document.getElementById(idModal);
		if(modal) {
			modal.classList.add('hide-dinamic-modal');
			modal.classList.remove('show-dinamic-modal');
		}

		setPosicion('');
	}

	function reload() {
        getPosiciones();
	}

	function filterArray(array) {
		array = array.filter(res => {
			if (res.posicion.toLowerCase().indexOf(filter) !== -1) {
				return true;
			} else {
				return false;
			}
		});
		return array;
	}

	function sortableTable(key) {
		let sd = new sortableData();
		const { items, direction } = sd.sortBy(key, posiciones, direccion[key]);

		setDireccion({
			[key]: direction
		});
		setPosiciones(posiciones);
		setFilterColumn({
			col: key,
			filt: direction
		});
	}

	return (
		<div className="owners column">
			<Helmet>
				<title>{process.env.REACT_APP_NAME} - {submenu}</title>
			</Helmet>
			<Header sidebar={true} active={'personalSeguridad'} parent={'personal'} nav={"administracion"} />
			<div className="row">
				<div className="column" id="sidebar">
					<SidebarAdministracion />
				</div>
				<div className="column" id="content">
					<div className="justify-center">
						<div className="container column">
							{lectura ?
							<React.Fragment>
								<Controls 
									title		=	{submenu}
									nuevo		=	{openModal.bind(this, 'modal-nueva-posicion')}
									dataSet		=	{filterArray(posiciones)}
									setFilter	=	{setFilter.bind(this)}
									newButton   =   {true}
									excelButton =   {false}
								/>
							{loadingPersonal?
								<div className="row justify-center">
									<i className="fas fa-spinner fa-spin"></i>
								</div>
								:
								<PosicionesTable 
									posiciones	=	{filterArray(posiciones)} 
									page		=	{page} 
									reload		=	{reload.bind(this)} 
									escritura	=	{escritura}
									pageLength	=   {pageLength}
									sortBy		=	{sortableTable.bind(this)}
									filterColumn=	{filterColumn}
									posicion	= 	{posicion}
									setPosicion = 	{setPosicion.bind(this)}
								/>
							}
							<div className="white-space-16"></div>
							<Paginador 
								pages={Math.ceil(filterArray(posiciones).length / pageLength)} 
								setPage={setPage.bind(this)} 
								pageLength = {pageLength} 
								paginatorChange = {paginatorChange.bind(this)} 
								showPageLenght = {true}/>
							<div className="white-space-16"></div>
							</React.Fragment>:
							null
							}
						</div>
					</div>
				</div>
			</div>
			<DinamicModal 
				idModal				=	{'modal-nueva-posicion'}
				sizeModalContainer	=	{'small'}
				title				=	{'Añadir posición'} 
				success				=	{handleSubmit.bind(this)} 
				showBtnSuccess		=	{true}
				btnTextSuccess		=	{"GUARDAR"}
				showBtnCancel		=	{true}
				btnTextCancel		=	{"CANCELAR"}
				loadingSave			=	{loadingSave}
				message				=	{message}
				closeModal			=	{closeModal.bind(this)}
			>
				<PosicionForm posicionInput={posicion} setPosicion={setPosicion.bind(this)} />
			</DinamicModal>
		</div>
	)
}

export default Consumer(Posiciones);
